import { useTranslation } from "react-i18next";
import { ShiftTrack } from "./ShiftTrack";
import { CheckoutCountdown } from "./CheckoutCountdown";

const toMin = (hhmm = "09:00") => {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + (m || 0);
};

const kindOf = (record, state) => {
  if (record?.status === "leave") return "leave";
  if (record?.status === "absent" || record?.absence_reason) return "absent";
  if (record?.check_out_at) return "done";
  if (record?.check_in_at) return "working";
  return state === "after" ? "absent" : "idle";
};

// خط زمن دوام اليوم: الحالة تحرّك الشريط (غائب · في العمل · مكتمل · عطلة) بلا عبارات زائدة.
export const ShiftProgress = ({ branch, record, day }) => {
  const { t } = useTranslation();
  if (!branch) return null;

  const start = toMin(branch.work_start);
  const baseEnd = toMin(branch.work_end);
  // اليوم المنتهي (انصراف أو غياب) لا تعويض فيه ولا إضافة على وقت الانصراف — انتهى ولا رجعة فيه.
  const closed = Boolean(record?.check_out_at) || record?.status === "absent" || record?.status === "leave" || Boolean(record?.absence_reason);
  const owed = closed ? 0 : Number(record?.compensation_minutes || 0);
  const end = baseEnd + owed;
  if (end <= start) return null;

  const now = new Date();
  const nowLocal = (((now.getUTCHours() * 60 + now.getUTCMinutes() + (branch.tz_offset_minutes ?? 0)) % 1440) + 1440) % 1440;
  const clock = Math.min(100, Math.max(0, ((nowLocal - start) / (end - start)) * 100));
  const state = nowLocal < start ? "before" : nowLocal >= end ? "after" : "during";
  // يوم عطلة (نهاية أسبوع/رسمية) بلا دوام مسموح وبلا حضور: نُظهر «عطلة» بدل «لم يبدأ/غائب».
  const worked = Boolean(record?.check_in_at || record?.check_out_at);
  const offDay = Boolean(day && day.day_type !== "workday" && !day.work_allowed);
  const base = kindOf(record, state);
  const kind = base === "leave" ? "leave" : offDay && !worked ? "off" : base;
  const pct = kind === "done" ? 100 : kind === "working" ? clock : 0;
  const status =
    kind === "leave"
      ? t("leaveStatus.onLeave", { type: t(`leaveStatus.types.${record.leave_type}`) })
      : kind === "off"
        ? t(day.day_type === "holiday" ? "check.shiftKind.holiday" : "check.shiftKind.weekend")
        : t(`check.shiftKind.${kind}`);

  return (
    <div className="mt-4 border-t border-border/40 pt-4" data-testid="shift-progress">
      <ShiftTrack
        pct={pct}
        kind={kind}
        start={branch.work_start}
        end={branch.work_end}
        owed={owed}
        title={null}
        status={status}
      />
      {owed ? (
        <p className="mt-2 text-[13px] font-bold text-amber-500" data-testid="late-compensation-note">
          {t("check.compensateOwed", { minutes: owed })}
        </p>
      ) : null}
      <CheckoutCountdown record={record} />
    </div>
  );
};
